<template>
    <span>
        <router-link
            v-if="customerId"
            class="btn btn-info"
            :to="{
                name: routeBase + '.customers.show',
                params: { id: customerId },
            }"
            target="_blank"
        >
            <i class="fa fa-building" /> View customer
        </router-link>

        <router-link
            v-if="isOffice && customerId && siteId"
            class="btn btn-info"
            :to="{
                name: 'office.sites.edit',
                params: { customer_id: customerId, id: siteId },
            }"
            target="_blank"
        >
            <i class="fa fa-map-marker-alt" /> View site
        </router-link>
    </span>
</template>

<script>
import RouterBaseMixin from "../../../mixins/RouterBaseMixin";

export default {
    name: "CustomerSiteFooterLinks",
    mixins: [RouterBaseMixin],
    props: {
        customerId: {
            type: [String, Number],
            default: null,
        },
        siteId: {
            type: [String, Number],
            default: null,
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/CustomerSiteFooterLinks.vue